module.exports = __webpack_public_path__ + "img/logo.4448b8de.png";